import clsx from 'clsx';
import React from 'react';
import { findIndex } from 'lodash';

import ProgressBar from '@/components/v2/UI/ProgressBar';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  value: string;
  options: { label: string; value: string }[];
}

const Characteristic: React.FC<Props> = ({ name, value, options }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <h3 className="h5">{t(`P_PDP.OVERVIEW.CHARACTERISTICS.${name}`)}</h3>

      <div className={clsx('flex', { 'space-x-1': true })}>
        {options.map((option, idx) => {
          const position =
            findIndex(options, ({ value: _value }) => _value === value)! + 1;

          const percentage = (position / options.length) * 100;
          const progress =
            percentage >= ((idx + 1) / options.length) * 100 ? 100 : 0;

          return (
            <div
              key={idx}
              className="w-full flex flex-col items-center space-y-3"
            >
              <div className="w-full overflow-hidden rounded-full">
                <ProgressBar value={progress} />
              </div>

              <p className="text-xs uppercase tracking-uyn text-center">
                {option.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Characteristic;
